import classNames from 'classnames';
import React from 'react';
import { CardSecondaryContent } from './card-secondary-content.react-component';
import commonStyles from "./common-card.module.css";
import styles from "./vertical-card.module.css";
/** Props for `VerticalCard` component */

/**
 * ### VerticalCard component.
 *
 * @remarks
 *
 * A card layout with a vertical stack of content.
 */
export const VerticalCard = _ref => {
  var _ref2, _ref3;

  let {
    action,
    authors,
    className,
    description,
    highlightedTag,
    iconButton,
    media,
    progress,
    secondaryContent,
    showSecondaryContentBorder = true,
    tags,
    title,
    statusLabel
  } = _ref;
  const hasPrimaryBottom = (_ref2 = (_ref3 = tags !== null && tags !== void 0 ? tags : progress) !== null && _ref3 !== void 0 ? _ref3 : statusLabel) !== null && _ref2 !== void 0 ? _ref2 : action;
  return /*#__PURE__*/React.createElement("section", {
    className: classNames(styles.card, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.primary
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['primary-top']
  }, /*#__PURE__*/React.createElement("div", null, media), /*#__PURE__*/React.createElement("div", {
    className: commonStyles['primary-head']
  }, /*#__PURE__*/React.createElement("div", null, title), description && /*#__PURE__*/React.createElement("div", null, description), authors && /*#__PURE__*/React.createElement("div", null, authors)), highlightedTag && /*#__PURE__*/React.createElement("div", {
    className: styles['highlighted-tag']
  }, highlightedTag)), hasPrimaryBottom && /*#__PURE__*/React.createElement("div", {
    className: styles['primary-bottom']
  }, tags && /*#__PURE__*/React.createElement("div", null, tags), progress && /*#__PURE__*/React.createElement("div", {
    className: styles.progress
  }, progress), (statusLabel || action) && /*#__PURE__*/React.createElement("div", {
    className: commonStyles['primary-content-spread']
  }, statusLabel && /*#__PURE__*/React.createElement("div", null, statusLabel), action && /*#__PURE__*/React.createElement("div", null, action))), iconButton && /*#__PURE__*/React.createElement("div", {
    className: styles['icon-button']
  }, iconButton)), secondaryContent && /*#__PURE__*/React.createElement(CardSecondaryContent, {
    showBorder: showSecondaryContentBorder
  }, secondaryContent));
};
//# sourceMappingURL=vertical-card.react-component.js.map